import { useCallback, useState } from "react";
import FilterNoneOutlinedIcon from "@mui/icons-material/FilterNoneOutlined";
import CropSquareOutlinedIcon from "@mui/icons-material/CropSquareOutlined";
import "./MapSidebar.css";
import CloseIcon from "@mui/icons-material/Close";
import FireOrigin from "../../molecules/fireOrigin/FireOrigin";
import FireContour from "../../molecules/fireContour/FireContour";
import FirePredictions from "../../molecules/firePredictions/FirePredictions";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
const MapSidebar = ({
  dfciCode,
  setDfciCode,
  onZoomToGrid,
  isSidebarPropagationOpen,
  onToggleSidebar,
  mapRef,
  handleSendPolygons,
  windSpeed,
  windDirection,
  fuelMoisture,
  temperatureParam,
  handleTemperatureChange,
  handleWindSpeedChange,
  handleWindDirectionChange,
  handleFuelMoistureChange,
  geoJsonResults,
  geoJsonResultAI,
  toggleContourBuildingsVisibility,
  toggleContourVisibility,
  //selectedOptionModel,
  // onChangeSelectedModel,
  selectedMeteoGetOption,
  onChangeSelectedMeteoOption,
  getPolygons,
  contourHour,
  setContourHour,
  contourDate,
  setContourDate,
  triggerTooltip,
  currentTimeZone,
  formattedCurrentDate,
  formattedCurrentTime,
  onChangeOriginFireRef,
  onChangeOriginFireDate,
  onChangeOriginFireHour,
  onChangeOriginFireLocation,
  originFireRef,
  originFireDate,
  originFireHour,
  originFireLocation,
  operationId,
  handleReset,
  handleExport,
  getPoints,
  onShowNavbarMenu,
  isSmallScreen,
  opacities,
  onHandleOpacity,
  //  postOriginFireData,
  modelErrorMessage,
  handleResetOpacity,
  geocoderContainerRefSidebar,
  setActiveTab,
  onShowUserComponent,
  onShowUserHistoricEvents,
  reducedWindow,
  onReduceEventCreationWindow,
  currentLoadingMessage,
  setCurrentLoadingMessage,
  buildingsLoading,
  drawRef,
  predictionHours,
  setPredictionHours,
  timeStep,
  setTimeStep,
  onShowAllBuildings,
  onHideAllBuildings,
  isLightMode,
  geoJsonInputContour,
}) => {
  const [openSection, setOpenSection] = useState("origin");
  const [showPregressBar, setShowPregressBar] = useState(false);
  const [validatedSections, setValidatedSections] = useState({
    origin: false,
    contour: false,
    predictions: false,
  });
  const resetValidatedSections = useCallback(() => {
  setValidatedSections({ origin: false, contour: false, predictions: false });
}, []);
  const toggleSection = useCallback((section) => {
    setOpenSection((prev) => (prev === section ? null : section));
  }, []);
  const returnToMenu = () => {
    onToggleSidebar();
    onShowNavbarMenu();
  };
  const validateSection = useCallback((section) => {
    setValidatedSections((prev) => ({ ...prev, [section]: true }));
  }, []);
  const toggleToContour = useCallback(
    () => toggleSection("contour"),
    [toggleSection],
  );
  const toggleToPredictions = useCallback(
    () => toggleSection("predictions"),
    [toggleSection],
  );
  const toggleToOrigin = useCallback(
    () => toggleSection("origin"),
    [toggleSection],
  );
  const validateOrigin = useCallback(
    () => validateSection("origin"),
    [validateSection],
  );
  const validateContour = useCallback(
    () => validateSection("contour"),
    [validateSection],
  );

  const reduceSidebarWindow = () => {
    onReduceEventCreationWindow();
    setOpenSection(null);
  };
  const maximizeSidebarWindow = () => {
    onReduceEventCreationWindow();
    setOpenSection("origin");
  };
  return (
    <div className={`sidebar ${isSidebarPropagationOpen ? "open" : ""}`}>
      <div className="drag-comp-header">
        <KeyboardDoubleArrowLeftIcon
          onClick={returnToMenu}
          className="drag-comp-returnIcon"
        />

        <div className="drag-comp-title">Création d'un événement</div>
        <div className="drag-header-icons">
          {reducedWindow ? (
            <CropSquareOutlinedIcon
              onClick={maximizeSidebarWindow}
              className="drag-comp-closeIcon"
              style={{ fontSize: "20px" }}
            />
          ) : (
            <FilterNoneOutlinedIcon
              onClick={reduceSidebarWindow}
              className="drag-comp-closeIcon"
              style={{ fontSize: "15px" }}
            />
          )}

          <CloseIcon
            onClick={onToggleSidebar}
            className="drag-comp-closeIcon"
            style={{ fontSize: "20px" }}
          />
        </div>
      </div>
      <div /* className="drag-comp-body" */>
        {/* Section: Origine de feu */}
        <div className="sidebar-section">
          <div
            className="sidebar-section-header"
            onClick={() => toggleSection("origin")}
          >
            Origine du feu (Situation initiale)
            <span>{openSection === "origin" ? "▲" : "▼"}</span>
          </div>
          <FireOrigin
            dfciCode={dfciCode}
            setDfciCode={setDfciCode}
            openSection={openSection}
            mapRef={mapRef}
            onZoomToGrid={onZoomToGrid}
            formattedCurrentDate={formattedCurrentDate}
            formattedCurrentTime={formattedCurrentTime}
            toggleFirstSection={toggleToContour}
            validateFirstSection={validateOrigin}
            onChangeOriginFireRef={onChangeOriginFireRef}
            onChangeOriginFireDate={onChangeOriginFireDate}
            onChangeOriginFireHour={onChangeOriginFireHour}
            onChangeOriginFireLocation={onChangeOriginFireLocation}
            originFireRef={originFireRef}
            originFireDate={originFireDate}
            originFireHour={originFireHour}
            originFireLocation={originFireLocation}
            // postOriginFireData={postOriginFireData}
            operationId={operationId}
            triggerTooltip={triggerTooltip}
            getPoints={getPoints}
            geocoderContainerRefSidebar={geocoderContainerRefSidebar}
          />
        </div>

        {/* Section: Contour de feu actuel */}
        <div
          className={`sidebar-section ${
            !validatedSections.origin ? "disabled" : ""
          }`}
        >
          <div
            className="sidebar-section-header"
            onClick={() => toggleSection("contour")}
          >
            Contour de feu actuel (Situation actuelle)
            <span>{openSection === "contour" ? "▲" : "▼"}</span>
          </div>
          <FireContour
            openSection={openSection}
            toggleSecondSection={toggleToPredictions}
            validateSecondSection={validateContour}
            toggleFirstSection={toggleToOrigin}
            handleSendPolygons={handleSendPolygons}
            mapRef={mapRef}
            windSpeed={windSpeed}
            windDirection={windDirection}
            fuelMoisture={fuelMoisture}
            temperatureParam={temperatureParam}
            handleTemperatureChange={handleTemperatureChange}
            handleWindSpeedChange={handleWindSpeedChange}
            handleWindDirectionChange={handleWindDirectionChange}
            handleFuelMoistureChange={handleFuelMoistureChange}
            //selectedOptionModel={selectedOptionModel}
            // onChangeSelectedModel={onChangeSelectedModel}
            selectedMeteoGetOption={selectedMeteoGetOption}
            onChangeSelectedMeteoOption={onChangeSelectedMeteoOption}
            onShowPregressBar={setShowPregressBar}
            contourHour={contourHour}
            setContourHour={setContourHour}
            contourDate={contourDate}
            setContourDate={setContourDate}
            getPolygons={getPolygons}
            getPoints={getPoints}
            triggerTooltip={triggerTooltip}
            currentTimeZone={currentTimeZone}
            handleReset={handleReset}
            geoJsonResults={geoJsonResults}
            isSmallScreen={isSmallScreen}
            originFireHour={originFireHour}
            originFireRef={originFireRef}
            originFireDate={originFireDate}
            handleResetOpacity={handleResetOpacity}
            drawRef={drawRef}
            predictionHours={predictionHours}
            setPredictionHours={setPredictionHours}
            timeStep={timeStep}
            setTimeStep={setTimeStep}
            isLightMode={isLightMode}
            resetValidatedSections={resetValidatedSections}
          />
        </div>

        {/* Section: Prédictions */}
        <div
          className={`sidebar-section ${
            !validatedSections.contour ? "disabled" : ""
          }`}
        >
          <div
            className="sidebar-section-header"
            onClick={() => toggleSection("predictions")}
          >
            Prédictions (Situations envisageables)
            <span>{openSection === "predictions" ? "▲" : "▼"}</span>
          </div>
          <FirePredictions
            openSection={openSection}
            toggleSecondSection={toggleToPredictions}
            geoJsonResults={geoJsonResults}
            geoJsonResultAI={geoJsonResultAI}
            toggleContourBuildingsVisibility={toggleContourBuildingsVisibility}
            toggleContourVisibility={toggleContourVisibility}
            showPregressBar={showPregressBar}
            handleExport={handleExport}
            opacities={opacities}
            onHandleOpacity={onHandleOpacity}
            modelErrorMessage={modelErrorMessage}
            handleReset={handleReset}
            toggleFirstSection={toggleToOrigin}
            setActiveTab={setActiveTab}
            onShowUserComponent={onShowUserComponent}
            onShowUserHistoricEvents={onShowUserHistoricEvents}
            currentLoadingMessage={currentLoadingMessage}
            setCurrentLoadingMessage={setCurrentLoadingMessage}
            buildingsLoading={buildingsLoading}
            predictionHours={predictionHours}
            timeStep={timeStep}
            onShowAllBuildings={onShowAllBuildings}
            onHideAllBuildings={onHideAllBuildings}
            geoJsonInputContour={geoJsonInputContour}
            isLightMode={isLightMode}
            isSmallScreen={isSmallScreen}
            onToggleSidebar={onToggleSidebar}
          />
        </div>
      </div>
    </div>
  );
};

export default MapSidebar;
